import find from 'lodash/find';
import union from 'lodash/union';

import individualTest from '../../../constants/json/checkboxes/individualTest.json';

const config = [
  {
    colId: 'testPackageId',
    field: 'testPackageId',
    headerName: 'Chemical Class',
    headerTooltip: 'Chemical Class',
    suppressHeaderMenuButton: true,
    resizable: true,
    width:400,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    sortable: true,
    sort: 'asc',
    valueFormatter: params => {
      if (params.value) {
        if (typeof params.value === 'string') {
          return params.value;
        } else {
          const chemicalClass =
          params.value &&
          find(
            union(
              individualTest[0].common,
              individualTest[0].toys,
              individualTest[0].electronic,
              individualTest[0].packaging,
              individualTest[0].jewelry
            ), [
            'id',
            params.value
          ]).label;
        return chemicalClass;
      }
      }
      return params.data.chemicalClass;
    },
    comparator: (a, b, nodeA, nodeB, isInverted) => {
    // Use the same logic as valueFormatter to get the display value for sorting
    const getDisplayValue = (value, data) => {
      if (value) {
        if (typeof value === 'string') {
          return value;
        } else {
          const chemicalClass =
            value &&
            find(
              union(
                individualTest[0].common,
                individualTest[0].toys,
                individualTest[0].electronic,
                individualTest[0].packaging,
                individualTest[0].jewelry
              ),
              ['id', value]
            )?.label;
          return chemicalClass || '';
        }
      }
      return data?.chemicalClass || '';
    };
    const valA = getDisplayValue(a, nodeA?.data);
    const valB = getDisplayValue(b, nodeB?.data);
    return valA.localeCompare(valB, undefined, { sensitivity: 'base' });
  },
    tooltipValueGetter: (params) => {
      if (params.value) {
        if (typeof params.value === 'string') {
          return params.value;
        } else {
          const chemicalClass =
          params.value &&
          find(
            union(
              individualTest[0].common,
              individualTest[0].toys,
              individualTest[0].electronic,
              individualTest[0].packaging,
              individualTest[0].jewelry
            ), [
            'id',
            params.value
          ]).label;
        return chemicalClass;
      }
      }
      return params.data.chemicalClass;
    }

  },
  {
    colId: 'chemicalName',
    headerName: 'Chemical Name',
    headerTooltip: 'Chemical Name',
    field: 'chemicalName',
    width:350,
    tooltipValueGetter: (params) => params.value,
    resizable: true,
    suppressHeaderMenuButton: true,
    sortable: true,
    sort: 'asc',
    comparator: (a, b) => {      
      return (a || '').localeCompare(b || '', undefined, { sensitivity: 'base' });
    }
  },
  {
    colId: 'CAS',
    headerName: 'CAS Number',
    headerTooltip: 'CAS Number',
    field: 'CAS',
    suppressHeaderMenuButton: true,
    resizable: true,
  },
  {
    colId: 'labLimit',
    headerName: 'Required Laboratory Reporting Limit',
    headerTooltip: 'Required Laboratory Reporting Limit',
    field: 'labLimit',
    resizable: true,
    width:400,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    tooltipValueGetter: (params) => params.value,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'white-space': 'normal', 'font-weight': 'normal' },
    valueFormatter: (params) => params.value
  },
  {
    colId: 'nikeLimit',
    headerName: 'Nike Limit',
    headerTooltip: 'Nike Limit',
    field: 'nikeLimit',
    resizable: true,
    tooltipValueGetter: (params) => params.value,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: {'font-weight': 'normal' },
    valueFormatter: (params) => params.value
  },
  {
    colId: 'testResultValue',
    headerName: 'Test Result',
    headerTooltip: 'Test Result',
    field: 'testResultValue',
    suppressHeaderMenuButton: true,
    editable: true,
    resizable: true,
  },
  {
    colId: 'unit',
    headerName: 'Unit',
    headerTooltip: 'Unit',
    field: 'unit',
    suppressHeaderMenuButton: true
  },
  {
    colId: 'specificLimit',
    headerName: 'Specific Limit',
    headerTooltip: 'Specific Limit',
    field: 'specificLimit',
    resizable: true,
    width:400,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    tooltipValueGetter: (params) => params.value,
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
    cellStyle: { 'white-space': 'normal', 'font-weight': 'normal' },
    valueFormatter: (params) => params.value
  }
];

// Create a new config Array of objects without mutating the parent array of objects
export const resultsTableReadonlyConfig =  [ ...config ].map(obj => obj.colId === 'testResultValue' ? {...obj, editable:false } : obj );

export default config;
